// assets
import { 
  DashboardOutlined, 
  RocketOutlined, 
  TeamOutlined
} from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  RocketOutlined,
  TeamOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'plans',
      title: 'Investment Plans',
      type: 'item',
      url: '/plans',
      icon: icons.RocketOutlined,
      breadcrumbs: true
    },
    {
      id: 'team',
      title: 'My Team',
      type: 'item',
      url: '/team',
      icon: icons.TeamOutlined,
      breadcrumbs: true
    }
  ]
};

export default dashboard;
